module.exports = __webpack_public_path__ + "assets/booking-logo.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/landing/booking-logo.png
// module id = 1206
// module chunks = 7